

export default {
  locale: 'fa',
  Pagination: {
    items_per_page: '/ صفحه',
    jump_to: 'برو به',
    jump_to_confirm: 'تایید',
    page: '',
    prev_page: 'صفحه قبلی',
    next_page: 'صفحه بعدی',
    prev_5: '۵ صفحه قبلی',
    next_5: '۵ صفحه بعدی',
    prev_3: '۳ صفحه قبلی',
    next_3: '۳ صفحه بعدی',
    page_size: 'اندازه صفحه'
  },
  DatePicker: {
    lang: {
      placeholder: 'انتخاب تاریخ',
      yearPlaceholder: 'انتخاب سال',
      monthPlaceholder: 'انتخاب ماه',
      weekPlaceholder: 'انتخاب هفته',
      rangePlaceholder: ['تاریخ شروع', 'تاریخ پایان'],
      rangeYearPlaceholder: ['سال شروع', 'سال پایان'],
      rangeMonthPlaceholder: ['ماه شروع', 'ماه پایان'],
      rangeWeekPlaceholder: ['هفته شروع', 'هفته پایان'],
      locale: 'fa_IR',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به روز',
      ok: 'باشه',
      clear: 'پاک کردن',
      month: 'ماه',
      year: 'سال',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      monthSelect: 'یک ماه را انتخاب کنید',
      yearSelect: 'یک سال را انتخاب کنید',
      decadeSelect: 'یک دهه را انتخاب کنید',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ماه قبل (PageUp)',
      nextMonth: 'ماه بعد (PageDown)',
      previousYear: 'سال قبل (Control + left)',
      nextYear: 'سال بعد (Control + right)',
      previousDecade: 'دهه قبل',
      nextDecade: 'دهه بعد',
      previousCentury: 'قرن قبل',
      nextCentury: 'قرن بعد',
      quarterPlaceholder: 'انتخاب فصل'
    },
    timePickerLocale: {
      placeholder: 'انتخاب زمان',
      rangePlaceholder: ['زمان شروع', 'زمان پایان']
    }
  },
  TimePicker: {
    placeholder: 'انتخاب زمان',
    rangePlaceholder: ['زمان شروع', 'زمان پایان']
  },
  Calendar: {
    lang: {
      placeholder: 'انتخاب تاریخ',
      rangePlaceholder: ['تاریخ شروع', 'تاریخ پایان'],
      locale: 'fa_IR',
      today: 'امروز',
      now: 'اکنون',
      backToToday: 'بازگشت به روز',
      ok: 'باشه',
      clear: 'پاک کردن',
      month: 'ماه',
      year: 'سال',
      timeSelect: 'انتخاب زمان',
      dateSelect: 'انتخاب تاریخ',
      monthSelect: 'یک ماه را انتخاب کنید',
      yearSelect: 'یک سال را انتخاب کنید',
      decadeSelect: 'یک دهه را انتخاب کنید',
      yearFormat: 'YYYY',
      dateFormat: 'M/D/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'M/D/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'ماه قبل (PageUp)',
      nextMonth: 'ماه بعد (PageDown)',
      previousYear: 'سال قبل (Control + left)',
      nextYear: 'سال بعد (Control + right)',
      previousDecade: 'دهه قبل',
      nextDecade: 'دهه بعد',
      previousCentury: 'قرن قبل',
      nextCentury: 'قرن بعد',
      yearPlaceholder: 'انتخاب سال',
      quarterPlaceholder: 'انتخاب فصل',
      monthPlaceholder: 'انتخاب ماه',
      weekPlaceholder: 'انتخاب هفته',
      rangeYearPlaceholder: ['سال شروع', 'سال پایان'],
      rangeMonthPlaceholder: ['ماه شروع', 'ماه پایان'],
      rangeWeekPlaceholder: ['هفته شروع', 'هفته پایان']
    },
    timePickerLocale: {
      placeholder: 'انتخاب زمان',
      rangePlaceholder: ['زمان شروع', 'زمان پایان']
    }
  },
  Table: {
    filterTitle: 'منوی فیلتر',
    filterConfirm: 'تایید',
    filterReset: 'پاک کردن',
    selectAll: 'انتخاب صفحه‌ی کنونی',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی',
    selectionAll: 'انتخاب همه داده‌ها',
    sortTitle: 'مرتب سازی',
    expand: 'باز شدن ردیف',
    collapse: 'بستن ردیف',
    triggerDesc: 'ترتیب نزولی',
    triggerAsc: 'ترتیب صعودی',
    cancelSort: 'لغوِ ترتیبِ داده شده',
    filterEmptyText: 'بدون فیلتر',
    emptyText: 'بدون داده',
    selectNone: 'انتخاب هیچکدام'
  },
  Modal: {
    okText: 'تایید',
    cancelText: 'لغو',
    justOkText: 'تایید'
  },
  Popconfirm: {
    okText: 'تایید',
    cancelText: 'لغو'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'جستجو',
    itemUnit: 'عدد',
    itemsUnit: 'عدد',
    remove: 'حذف',
    selectCurrent: 'انتخاب صفحه فعلی',
    removeCurrent: 'پاک کردن انتخاب‌های صفحه فعلی',
    selectAll: 'انتخاب همه',
    removeAll: 'پاک کردن همه انتخاب‌ها',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی'
  },
  Upload: {
    uploading: 'در حال آپلود...',
    removeFile: 'حذف فایل',
    uploadError: 'خطا در آپلود',
    previewFile: 'مشاهده‌ی فایل',
    downloadFile: 'دریافت فایل'
  },
  Empty: {
    description: 'داده‌ای موجود نیست'
  },
  Icon: {
    icon: 'آیکن'
  },
  Text: {
    edit: 'ویرایش',
    copy: 'کپی',
    copied: 'کپی شد',
    expand: 'توسعه'
  },
  PageHeader: {
    back: 'برگشت'
  },
  global: {
    placeholder: 'لطفاً انتخاب کنید'
  },
  Image: {
    preview: 'نمایش'
  }
};
